import React from "react";

import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    TextField,
    Typography,
} from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

function AppraisalInitiateFormDialog({
    open,
    onSave,
    onClose,
    lastDueDate,
    setLastDueDate,
    nextDueDate,
    setNextDueDate,
    ...props
}) {
    const today = new Date(); // get today's date
    const twoYearsLater = new Date(
        today.getFullYear() + 2,
        today.getMonth(),
        today.getDate()
    );

    const minStartDate = "2010-01-01 00:00:00";
    const maxStartDate = twoYearsLater;
    const maxMeetingDate = maxStartDate;

    return (
        <Dialog
            open={true}
            onClose={onClose}
            fullWidth={true}
            maxWidth="md"
            {...props}
        >
            <DialogTitle>Initiate a new appraisal</DialogTitle>
            <DialogContent dividers={false}>
                <Box
                    component="form"
                    autoComplete="off"
                    noValidate
                    className="dialog-content"
                    onSubmit={(e) => e.preventDefault()}
                >
                    <Typography variant="p" component="p">
                        We require some information before we can initiate your
                        new appraisal.
                    </Typography>
                    <Box className="form-row">
                        <Typography component="p" mb={2}>
                            If you know the date of your last appraisal meeting,
                            add it here.
                        </Typography>
                        <FormControl component="div" fullWidth={false}>
                            <DatePicker
                                id="date-last-due"
                                label="Date"
                                format="DD/MM/YYYY"
                                value={dayjs(lastDueDate)}
                                minDate={dayjs(minStartDate)}
                                maxDate={dayjs(maxStartDate)}
                                onChange={setLastDueDate}
                                renderInput={(params) => (
                                    <TextField {...params} />
                                )}
                            />
                        </FormControl>
                    </Box>
                    <Box className="form-row">
                        <Typography component="p" mb={2}>
                            if not, then you can add the date of your next
                            appraisal meeting here.
                        </Typography>
                        <FormControl component="div" fullWidth={false}>
                            <DatePicker
                                id="date-next-due"
                                label="Date"
                                format="DD/MM/YYYY"
                                value={dayjs(nextDueDate)}
                                minDate={dayjs(nextDueDate || minStartDate)}
                                maxDate={dayjs(maxMeetingDate)}
                                onChange={setNextDueDate}
                                renderInput={(params) => (
                                    <TextField {...params} />
                                )}
                                required
                            />
                        </FormControl>
                    </Box>
                </Box>

                <DialogContentText>
                    <Typography variant="p" component="p">
                        Make sure you have answered one of the questions above.
                    </Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    key="add"
                    variant="contained"
                    color="primary"
                    disableElevation={true}
                    onClick={onSave}
                >
                    Initiate
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AppraisalInitiateFormDialog;
